// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"202":"cab91405","683":"9b997c87","784":"8876ab19"}[chunkId] + ".css";
};